import styles from "./EditTask.module.css";
import { useState } from "react";
import TimePickerInput from "../../../../../components/timePickerInput/TimePickerInput";
import DatePickerInput from "../../../../../components/datePickerInput/DatePickerInput";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { Col, Row } from "antd";
import Dropdown from "../../../../../components/dropdowns/Dropdown";
import Modal from "../../../../../components/modal/Modal";
import { MdAddCircle } from "react-icons/md";
import { CalendarIcon, ClockIcon } from "../../../../../components/icons/Icons";
import { IoMdCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const inputsArr = [
  {
    id: 2,
    multiple: true,
    type: "text",
    fullWidth: true,
    list: [{ label: "Sub Task", placeholder: "Finalize Dress" }],
  },
];

const EditTask = () => {
  const [inputs, setInputs] = useState(inputsArr);
  const navigate = useNavigate();

  const AddTask = (id) => {
    setInputs((prev) =>
      prev.map((el) => {
        if (el.id === id) {
          return {
            ...el,
            list: [
              ...el.list,
              {
                label: "Sub Task",
                placeholder: "Finalize Dress",
              },
            ],
          };
        } else {
          return el;
        }
      })
    );
  };

  const DeleteTask = (id, i) => {
    setInputs((prev) =>
      prev.map((el) => {
        if (el.id === id) {
          return { ...el, list: el.list.filter((item, index) => index !== i) };
        } else {
          return el;
        }
      })
    );
  };

  return (
    <>
      <Row className={styles.secondStepContainer} gutter={16}>
        <Col xs={24}>
          <InputField label="Task" placeholder="Wedding Dress" />
        </Col>
        {inputs.map((input) => (
          <Col xs={24} md={input.fullWidth ? 24 : 12}>
            {input?.list?.map((inp, i) => (
              <Row className={styles.inputRow}>
                <>
                  <Col xs={20} sm={21} md={22} xl={23}>
                    <InputField
                      label={inp.label}
                      type={inp.type}
                      value={inp.value}
                      name={inp.name}
                      rightIcon={inp.rightIcon}
                      maxLength={inp.maxLength}
                      placeholder={inp.placeholder}
                      // onChange={handleValues}
                    />
                  </Col>
                  {i === input.list.length - 1 ? (
                    <Col
                      xs={4}
                      sm={3}
                      md={2}
                      xl={1}
                      className={styles.addBtnCol}
                    >
                      <MdAddCircle
                        size={25}
                        className={styles.addBtn}
                        onClick={() => AddTask(input.id)}
                      />
                    </Col>
                  ) : (
                    <Col
                      xs={4}
                      sm={3}
                      md={2}
                      xl={1}
                      className={styles.addBtnCol}
                    >
                      <IoMdCloseCircle
                        size={25}
                        className={styles.addBtn}
                        onClick={() => DeleteTask(input.id, i)}
                      />
                    </Col>
                  )}
                </>
              </Row>
            ))}
          </Col>
        ))}
        <Col xs={24} md={12}>
          <TimePickerInput label="Set Time" icon={<ClockIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <Dropdown
            stylesClass={styles.dropdownClass}
            placeholder={"2 Hr"}
            name={"role"}
            label={"Remind Me After"}
            options={[
              { value: "2 Hr", option: "2 Hr" },
              { value: "3 Hr", option: "3 Hr" },
            ]}
          />
        </Col>
        <Col xs={24} md={12}>
          <DatePickerInput label="Date" icon={<CalendarIcon size={25} />} />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} xl={8}>
          <SubmitButton
            title={"Save"}
            btnClass={styles.solidBtn}
            onClick={() => navigate(-1)}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditTask;
